(() => {
  const INSTAGRAM_URL = 'https://www.instagram.com/tbkmotorsports/';
  const STYLE_ID = 'tbk-header-instagram-style';
  const LINK_CLASS = 'tbk-header-instagram-link';
  const BRAND_CLASS = 'tbk-header-brand';
  const BRAND_IMAGE_CLASS = 'tbk-header-brand__image';
  const BUILDS_WRAPPER_ID = 'shopify-section-template--20958068080795__tbk-home-builds-v2-1781187507774';

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .header__icons .${LINK_CLASS} {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 4.4rem;
        height: 4.4rem;
        padding: 0;
        color: inherit;
        text-decoration: none;
      }

      .header__icons .${LINK_CLASS} svg {
        width: 2.8rem;
        height: 2.8rem;
        display: block;
        filter: drop-shadow(0 4px 9px rgba(214, 36, 159, .25));
        transition: transform .18s ease, filter .18s ease;
      }

      .header__icons .${LINK_CLASS}:hover svg {
        transform: translateY(-1px) scale(1.06);
        filter: drop-shadow(0 6px 14px rgba(214, 36, 159, .35));
      }

      .${BRAND_CLASS} {
        display: inline-flex;
        align-items: center;
        width: clamp(14rem, 13vw, 19rem);
        max-width: 42vw;
      }

      .${BRAND_IMAGE_CLASS} {
        display: block;
        width: 100%;
        height: auto;
        max-height: 5.2rem;
        object-fit: contain;
      }

      @media screen and (max-width: 749px) {
        .header__icons .${LINK_CLASS} {
          width: 3.9rem;
          height: 3.9rem;
        }

        .header__icons .${LINK_CLASS} svg {
          width: 2.55rem;
          height: 2.55rem;
        }

        .${BRAND_CLASS} {
          width: min(36vw, 13.5rem);
        }

        .${BRAND_IMAGE_CLASS} {
          max-height: 4rem;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function logoSource() {
    const script = document.currentScript || Array.from(document.scripts).find(item => item.src && item.src.includes('tbk-header-instagram.js'));
    if (script && script.src) return script.src.replace(/tbk-header-instagram\.js(?:\?.*)?$/, 'tbk-header-logo.png');
    return 'https://tbkmotorsports.com/cdn/shop/t/4/assets/tbk-header-logo.png';
  }

  function iconMarkup() {
    return `
      <svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">
        <defs>
          <radialGradient id="tbk-header-instagram-runtime-gradient" cx="30%" cy="107%" r="120%">
            <stop offset="0" stop-color="#fdf497"/>
            <stop offset=".18" stop-color="#fdf497"/>
            <stop offset=".42" stop-color="#fd5949"/>
            <stop offset=".68" stop-color="#d6249f"/>
            <stop offset="1" stop-color="#285aeb"/>
          </radialGradient>
        </defs>
        <rect x="4" y="4" width="40" height="40" rx="12" fill="url(#tbk-header-instagram-runtime-gradient)"/>
        <rect x="14" y="14" width="20" height="20" rx="6.2" fill="none" stroke="#fff" stroke-width="3"/>
        <circle cx="24" cy="24" r="5.5" fill="none" stroke="#fff" stroke-width="3"/>
        <circle cx="31.5" cy="16.5" r="2.1" fill="#fff"/>
      </svg>
      <span class="visually-hidden">Instagram</span>
    `;
  }

  function buildLink() {
    const link = document.createElement('a');
    link.href = INSTAGRAM_URL;
    link.className = `header__icon header__icon--instagram link focus-inset ${LINK_CLASS}`;
    link.target = '_blank';
    link.rel = 'noopener';
    link.setAttribute('aria-label', 'Open TBK Motorsports Instagram');
    link.innerHTML = iconMarkup();
    return link;
  }

  function replaceTextLogo() {
    const logo = logoSource();
    document.querySelectorAll('.header__heading-link').forEach((link) => {
      if (link.querySelector(`.${BRAND_IMAGE_CLASS}`)) return;
      const label = (link.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/^(TBK|CBK) Motorsports$/i.test(label)) return;
      link.innerHTML = `<span class="${BRAND_CLASS}"><img src="${logo}" alt="TBK Motorsports" class="${BRAND_IMAGE_CLASS}" width="720" height="210" loading="eager"></span>`;
    });
  }

  function isHomePath() {
    return location.pathname === '/' || location.pathname === '';
  }

  function findBuildsTarget() {
    return document.getElementById('builds')
      || document.getElementById(BUILDS_WRAPPER_ID)
      || document.querySelector('.tbk-builds-v2');
  }

  function scrollToBuilds(useSmooth = true) {
    const target = findBuildsTarget();
    if (!target) return false;
    const header = document.querySelector('.shopify-section-header-sticky, sticky-header, .header-wrapper, header');
    const offset = Math.max(92, Math.min(150, (header?.getBoundingClientRect().height || 104) + 22));
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: useSmooth ? 'smooth' : 'auto' });
    return true;
  }

  function installBuildsScroll() {
    if (!window.__tbkBuildsScrollInstalled) {
      window.__tbkBuildsScrollInstalled = true;
      document.addEventListener('click', (event) => {
        const link = event.target.closest?.('a[href="#builds"], a[href="/#builds"], #HeaderMenu-builds, #HeaderDrawer-builds');
        if (!link) return;
        if (!isHomePath()) return;
        if (!findBuildsTarget()) return;
        event.preventDefault();
        history.replaceState(null, '', '#builds');
        scrollToBuilds(true);
      });
      window.addEventListener('hashchange', () => {
        if (location.hash === '#builds') setTimeout(() => scrollToBuilds(true), 80);
      });
    }
    if (location.hash === '#builds') {
      setTimeout(() => scrollToBuilds(false), 150);
      setTimeout(() => scrollToBuilds(false), 650);
    }
  }


  // TBK stale vehicle menu guard: remove dead vehicle links if Shopify serves a cached drawer.
  const DELETED_VEHICLE_LINKS = [
    '/collections/ferrari-purosangue',
    '/collections/ferrari-gtc4-lusso',
  ];

  function removeDeletedVehicleLinks(root = document) {
    DELETED_VEHICLE_LINKS.forEach((href) => {
      root.querySelectorAll?.(`a[href="${href}"], a[href*="${href}"]`).forEach((link) => {
        const item = link.closest('li') || link;
        item.remove();
      });
    });
  }

  function watchDeletedVehicleLinks() {
    if (window.__tbkDeletedVehicleMenuGuardInstalled) return;
    window.__tbkDeletedVehicleMenuGuardInstalled = true;
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) removeDeletedVehicleLinks(node);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function install() {
    removeDeletedVehicleLinks();
    watchDeletedVehicleLinks();
    addStyles();
    replaceTextLogo();
    installBuildsScroll();
    document.querySelectorAll('.header__icons').forEach((icons) => {
      if (icons.querySelector(`.${LINK_CLASS}, .header__icon--instagram[href*="instagram.com/tbkmotorsports"]`)) return;
      const search = icons.querySelector('.header__search, .header__icon--search');
      icons.insertBefore(buildLink(), search || icons.firstChild);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install, { once: true });
  } else {
    install();
  }
  document.addEventListener('shopify:section:load', install);
})();